import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Pagination } from "semantic-ui-react";
import { getUsers } from "../../../api/users";
import { useErrorNotification } from "../../../hooks/useErrorNotification";
import { useUserLicenceQuotaMessage } from "../../../hooks/useUserLicenceQuotaMessage";
import PageLoader from "../../PageLoader";
import { Btn, Notice, PageHeader } from "../../ui";
import UsersTable from "./UsersTable";

const QUOTA_TONES = { red: "error", yellow: "warning" };

const ListUsers = () => {
  const [page, setPage] = useState("1");

  const {
    data: usersData,
    isError,
    isLoading,
  } = useQuery(
    ["users", page],
    () => {
      return getUsers({ page: page });
    },
    {
      keepPreviousData: true,
      staleTime: 60000,
    },
  );

  const licenceQuotaMessage = useUserLicenceQuotaMessage(
    usersData?.data?.meta?.licenses?.sidekick,
  );

  const handlePaginationChange = (e, { activePage }) => {
    setPage(activePage);
  };

  useErrorNotification({
    isError,
    title: "Error getting users",
    toastId: "user-list-error",
  });

  if (isLoading) return <PageLoader />;

  return (
    <>
      <PageHeader
        eyebrow="Admin"
        title="Manage Users"
        actions={
          <Btn as={Link} to="/admin/users/create" variant="primary">
            Add User
          </Btn>
        }
      />
      {licenceQuotaMessage && (
        <Notice tone={QUOTA_TONES[licenceQuotaMessage.color] ?? "neutral"}>
          {licenceQuotaMessage.message}
        </Notice>
      )}

      <UsersTable data={usersData?.data?.data} />

      <div style={{ textAlign: "center" }}>
        <Pagination
          inverted
          activePage={page}
          totalPages={usersData?.data.meta.last_page}
          onPageChange={handlePaginationChange}
        />
      </div>
    </>
  );
};

export default ListUsers;
